import { MatLabel } from '@angular/material/form-field';
import { Component, Injector, ChangeDetectionStrategy } from '@angular/core';

import { DtoComponent, createDtoProperties, SimpleFormComponent, SimpleFormSectionComponent, SimpleFormRowComponent, MgFormControlDirective } from '@mango/core';
import { Alert } from './alert';
import { AlertService } from './alert.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatInput, MatSuffix, MatError } from '@angular/material/input';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';

@Component({
    selector: 'dla-app-alert',
    templateUrl: './alert.component.html' /*,
    styleUrls: ['./alert.component.css']*/,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SimpleFormComponent, FormsModule, ReactiveFormsModule, SimpleFormSectionComponent, SimpleFormRowComponent, MatFormField, MatLabel, MatInput, MatDatepickerInput, MgFormControlDirective, MatDatepickerToggle, MatSuffix, MatDatepicker, MatError, CdkTextareaAutosize]
})
export class AlertComponent extends DtoComponent<Alert> {
    properties = createDtoProperties<Alert>([
        'title',
        'message',
        'date',
        'type',
        'expiringDate',
        {'receivedBy': ['id']}
    ]);

    constructor(
        service: AlertService,
        injector: Injector) {
        super(service, Alert);
    }

    ngOnInit() {
        super.ngOnInit();

        this.handleRoute("id");
    }
}
